import { Link } from "react-router-dom";
import { Mail, ArrowUpRight, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-32 border-t border-white/10 bg-[#05050a] overflow-hidden"
    >
      <div className="glow-orb w-[420px] h-[280px] bg-blue-700/15 left-1/2 -translate-x-1/2 -top-32" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5">
              <div className="w-10 h-10 grid place-items-center">
                <img src="/equinox-logo.png" alt="Equinox Systems logo" className="w-full h-full object-contain drop-shadow-[0_0_10px_rgba(10,132,255,0.5)]" />
              </div>
              <div>
                <div className="font-display font-semibold text-lg">Equinox Systems</div>
                <div className="text-xs uppercase tracking-widest text-gray-500">
                  A Freedom Core Ventures Company
                </div>
              </div>
            </div>
            <p className="mt-5 text-gray-400 max-w-md leading-relaxed">
              Enterprise-grade websites, applications, CRMs, and AI-driven systems —
              engineered for businesses that want to operate smarter and scale faster.
            </p>
            <a
              href="mailto:Equinox@freedomcoreventures.com"
              data-testid="footer-email-link"
              className="mt-6 inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors group"
            >
              <Mail className="w-4 h-4 text-blue-400" /> Equinox@freedomcoreventures.com
              <ArrowUpRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
            </a>
            <div className="mt-6 flex items-center gap-3" data-testid="footer-socials">
              <a
                href="https://www.instagram.com/equinox_systems/"
                target="_blank"
                rel="noreferrer"
                aria-label="Equinox Systems on Instagram"
                data-testid="footer-instagram-link"
                className="w-10 h-10 rounded-xl grid place-items-center bg-white/[0.04] border border-white/10 text-gray-300 transition-all duration-300 hover:text-white hover:border-blue-500/40 hover:bg-white/[0.07] hover:shadow-[0_0_20px_rgba(10,132,255,0.35)]"
              >
                <Instagram className="w-5 h-5" strokeWidth={1.7} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61590765742836"
                target="_blank"
                rel="noreferrer"
                aria-label="Equinox Systems on Facebook"
                data-testid="footer-facebook-link"
                className="w-10 h-10 rounded-xl grid place-items-center bg-white/[0.04] border border-white/10 text-gray-300 transition-all duration-300 hover:text-white hover:border-blue-500/40 hover:bg-white/[0.07] hover:shadow-[0_0_20px_rgba(10,132,255,0.35)]"
              >
                <Facebook className="w-5 h-5" strokeWidth={1.7} />
              </a>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest text-gray-500 mb-4">
              Company
            </div>
            <ul className="space-y-2.5 text-sm">
              <li><Link className="text-gray-300 hover:text-white transition-colors" to="/apply" data-testid="footer-link-apply">Free Website</Link></li>
              <li><Link className="text-gray-300 hover:text-white transition-colors" to="/services" data-testid="footer-link-services">Services</Link></li>
              <li><Link className="text-gray-300 hover:text-white transition-colors" to="/packages" data-testid="footer-link-packages">Packages</Link></li>
              <li><Link className="text-gray-300 hover:text-white transition-colors" to="/hosting" data-testid="footer-link-hosting">Hosting</Link></li>
              <li><Link className="text-gray-300 hover:text-white transition-colors" to="/portfolio" data-testid="footer-link-portfolio">Portfolio</Link></li>
              <li><Link className="text-gray-300 hover:text-white transition-colors" to="/about" data-testid="footer-link-about">About</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest text-gray-500 mb-4">
              Resources
            </div>
            <ul className="space-y-2.5 text-sm">
              <li><Link className="text-gray-300 hover:text-white transition-colors" to="/contact" data-testid="footer-link-contact">Contact</Link></li>
              <li><Link className="text-gray-300 hover:text-white transition-colors" to="/faq" data-testid="footer-link-faq">FAQ</Link></li>
              <li><Link className="text-gray-300 hover:text-white transition-colors" to="/quote" data-testid="footer-link-quote">Get a Quote</Link></li>
              <li><Link className="text-gray-300 hover:text-white transition-colors" to="/privacy" data-testid="footer-link-privacy">Privacy Policy</Link></li>
              <li><Link className="text-gray-300 hover:text-white transition-colors" to="/terms" data-testid="footer-link-terms">Terms &amp; Conditions</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-gray-500">
          <div>© {new Date().getFullYear()} Equinox Systems · equinoxsystems.tech</div>
          <div>Stripe-secure payments · Veteran-owned · Built for growth</div>
        </div>
      </div>
    </footer>
  );
}
